import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';

interface JobParametersProps {
    jobData: any;
}

const JobParameters: React.FC<JobParametersProps> = ({ jobData }) => {
    // Find the JOB type entry in parsed_json_data
    const jobEntry = jobData?.parsed_json_data?.find((item: any) => item.Type === 'JOB');

    if (!jobEntry) {
        return (
            <div className="text-center py-12 text-gray-500">
                <p>No job parameters found</p>
            </div>
        );
    }

    // Extract job parameters (exclude Type)
    const jobParams = Object.entries(jobEntry)
        .filter(([key]) => key !== 'Type')
        .map(([key, value]) => ({ key, value }));

    return (
        <div className="p-6 space-y-4">
            <Card className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">
                        Job Configuration — {jobData.job_number}
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-4">
                        {jobParams.map(({ key, value }) => (
                            <div key={key} className="min-w-0">
                                <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">
                                    {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                </div>
                                <div className="text-[13px] font-medium text-text-grey font-mono">
                                    {String(value)}
                                </div>
                            </div>
                        ))}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default JobParameters;
